import {Stack} from "expo-router";
import WebHeader from "@/lib/components/WebHeader";
import {Platform} from "react-native";
import EventHeader from "@/lib/components/EventHeader";

export const unstable_settings = {
    initialRouteName: 'index',
};

export default function StackLayout() {
    return (
        <Stack
            initialRouteName={"index"}
            screenOptions={{
                header: Platform.OS === "web" ? WebHeader : undefined,
                headerBackButtonDisplayMode: "minimal",
            }}
        >
            <Stack.Screen name="index" options={{title: "Chat"}}/>
            <Stack.Screen name="[chat_id]/index" options={{title: "Meldingslogg", headerRight: EventHeader}}/>
            <Stack.Screen name="[chat_id]/edit" options={{title: "Innstillinger"}}/>
            <Stack.Screen name="[chat_id]/preferences" options={{title: "Varsling"}}/>
        </Stack>
    );
}